// Manager dashboard — performance-metric percentage RAG colors.
// Thresholds (per E20-6283 follow-up / RAG):
//   > 80%       -> green
//   60% to 80%  -> amber
//   < 60%       -> red
const PERCENT_RED = '#E23636';
const PERCENT_AMBER = '#FABB00';
const PERCENT_GREEN = '#2AA154';
const NEUTRAL_GRAY = '#c8d6e5'


const TRAIL_RED = '#fce4e4';
const TRAIL_AMBER = '#fef3cd';
const TRAIL_GREEN = '#e8f5e9';
const TRAIL_GRAY = '#eef0f4'

export type MetricIconState = 'check' | 'warning';

export const getPercentageColor = (value?: number | null): string | undefined => {
    if (value === null || value === undefined) return '#2C3E50';
    if (value > 80) return PERCENT_GREEN;
    if (value >= 60) return PERCENT_AMBER;
    return PERCENT_RED;
};

// Light track tint paired with the donut ring color for each RAG band.
export const getPercentageTrailColor = (value?: number | null): string => {
    if (value === null || value === undefined) return TRAIL_GRAY;
    if (value > 80) return TRAIL_GREEN;
    if (value >= 60) return TRAIL_AMBER;
    return TRAIL_RED;
};

export const getCoachingEffectivenessColor = (value?: number | null): string => {
    if (value == null) return NEUTRAL_GRAY;
    if (value < 40) return PERCENT_RED;
    if (value < 60) return PERCENT_AMBER;
    return PERCENT_GREEN;
};

export const getCoachingEffectivenessTrailColor = (value?: number | null): string => {
    if (value == null) return TRAIL_GRAY;
    if (value < 40) return TRAIL_RED;
    if (value < 60) return TRAIL_AMBER;
    return TRAIL_GREEN;
};

export const getPercentageIcon = (value?: number | null): MetricIconState => {
    if (value == null) return 'warning';
    if (value > 80) return 'check';
    return 'warning';
};

export const getCoachingEffectivenessIcon = (value?: number | null): MetricIconState => {
    if (value == null) return 'warning';
    return value >= 60 ? 'check' : 'warning';
};
